<template>
    <el-dialog title="菜单维护" :visible="visible" :show="show" width="50%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px">
            <el-form-item label="菜单名称" class="input" prop="resName">
                <el-input v-model="ruleForm.resName" autocomplete="off" placeholder="请输入菜单名称"/>
            </el-form-item>
            <el-form-item label="是否为叶子节点菜单" class="input" prop="isFolder">
                <el-radio v-model="ruleForm.isFolder" label="1">是</el-radio>
                <el-radio v-model="ruleForm.isFolder" label="2">否</el-radio>
            </el-form-item>
            <el-form-item label="菜单别名" class="input" prop="alias">
                <el-input v-model="ruleForm.alias" autocomplete="off" placeholder="请输入菜单别名"/>
            </el-form-item>
            <el-form-item label="同组排序" class="input" prop="sn">
                <el-input-number :controls="false" :min="1" :max="99" v-model="ruleForm.sn" autocomplete="off" placeholder="同组排序" style="width:80%"/>
            </el-form-item>
            <el-form-item label="默认地址" class="input" prop="defaultUrl">
                <el-input v-model="ruleForm.defaultUrl" autocomplete="off" placeholder="请输入默认地址"/>
            </el-form-item>

            <el-form-item label="按钮类型" class="input" prop="btnListArr">
                <el-select v-model="btnListArr" style="width:80%" multiple>
                    <el-option v-for="(item,i) in menuBtnList" :label="item.indexName" :key="item.id"
                               :value="item.codeIndex+''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图标" class="input" prop="icons">
                <el-input v-model="ruleForm.icons" autocomplete="off" placeholder="请输入图标"/>
            </el-form-item>
            <el-form-item label="是否显示" class="input" prop="isDisplayInMenu">
                <el-select v-model="ruleForm.isDisplayInMenu" style="width:80%" >
                    <el-option :label="'是'" :value="'1'"></el-option>
                    <el-option :label="'否'" :value="'2'"></el-option>
                </el-select>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initOrgTypeList();
                }
            },
            rowData(){
                if(this.rowData.type=='edit'){
                    this.ruleForm = this.rowData;
                    if (this.rowData.btnList!='' && this.rowData.btnList!=undefined){
                        this.btnListArr = this.rowData.btnList.split(",");

                    }
                }else{
                    this.ruleForm.parentId = this.rowData.id;
                }
                this.$forceUpdate();
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    resName:'',
                    alias:'',
                    sn:1,
                    isFolder:'',
                    btnList:'',
                    isDisplayInMenu:'',
                    btnListArr:[],
                },
                rules:{
                    resName:[{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
                    alias:[{ required: true, message: '请选择菜单别名', trigger: 'blur' }],
                    sn:[{ required: true, message: '请输入同组排序', trigger: 'blur' }],
//                    btnList:[{ required: true, message: '请选择菜单按钮', trigger: 'blur' }],
                    isDisplayInMenu:[{ required: true, message: '是否展示', trigger: 'blur' }],
                },
                menuBtnList:[],
                btnListArr:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.ruleForm.btnList = this.btnListArr.join(",");
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`menu/`+"save":this.url+`menu/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            initOrgTypeList(){
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "menu_types"//编码名字
                params['dicName'] = "按钮类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.menuBtnList = data.data.list;
                    }
                });
            },
        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>